import React from "react";
import ReactDOM from "react-dom";
import QuantityOption from "./QuantityOption";
import CustomQuantity from "./CustomQuantity";

class QuantityDropdown extends React.Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
    document.addEventListener("click", this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
    document.removeEventListener("click", this.handleClick, false);
  }

  handleKeyDown = (event) => {
    const ESCAPE_KEY = 27;
    if (event.keyCode === ESCAPE_KEY) {
      this.props.handleCloseDropdown();
    }
  };

  handleClick = (event) => {
    if (
      !ReactDOM.findDOMNode(this).contains(event.target) &&
      this.props.dropdownActive
    ) {
      this.props.handleCloseDropdown();
    }
  };

  render() {
    let dropdown = [];

    for (var prop in this.props.pricebreaks) {
      dropdown.push(
        <QuantityOption
          key={prop}
          quantity={prop}
          pricebreak={this.props.pricebreaks[prop]}
          initialPrice={this.props.initialPrice}
          selectedQuantity={this.props.quantity.toString()}
          handleUpdateQuantity={this.props.handleUpdateQuantity}
          handleUpdateSavings={this.props.handleUpdateSavings}
          handleCloseDropdown={this.props.handleCloseDropdown}
        />
      );
    }

    const customOption = (
      <QuantityOption
        quantity={this.props.quantity}
        pricebreak={this.props.price}
        initialPrice={this.props.initialPrice}
        selectedQuantity={this.props.quantity.toString()}
        handleUpdateQuantity={this.props.handleUpdateQuantity}
        handleUpdateSavings={this.props.handleUpdateSavings}
        handleCloseDropdown={this.props.handleCloseDropdown}
      />
    );

    return (
      <div className="quantity-dropdown__pricebreaks">
        <CustomQuantity
          quantity={this.props.quantity}
          minimumQuantity={this.props.minimumQuantity}
          quantityIncrement={this.props.quantityIncrement}
          handleUpdateQuantity={this.props.handleUpdateQuantity}
        />

        {!this.props.pricebreaks.hasOwnProperty(this.props.quantity) && (
          <div>{customOption}</div>
        )}
        {dropdown}
      </div>
    );
  }
}

export default QuantityDropdown;
